var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Order(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-order",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M8,.4A1.2,1.2,0,0,1,9.2,1.6V8A1.2,1.2,0,0,1,8,9.2H1.6A1.2,1.2,0,0,1,.4,8V1.6A1.2,1.2,0,0,1,1.6.4H8M8,0H1.6A1.6,1.6,0,0,0,0,1.6V8A1.6,1.6,0,0,0,1.6,9.6H8A1.6,1.6,0,0,0,9.6,8V1.6A1.6,1.6,0,0,0,8,0Z",
    fill: "#02466a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(10.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M60,.4a1.2,1.2,0,0,1,1.2,1.2V8A1.2,1.2,0,0,1,60,9.2H53.6A1.2,1.2,0,0,1,52.4,8V1.6A1.2,1.2,0,0,1,53.6.4H60M60,0H53.6A1.6,1.6,0,0,0,52,1.6V8a1.6,1.6,0,0,0,1.6,1.6H60A1.6,1.6,0,0,0,61.6,8V1.6A1.6,1.6,0,0,0,60,0Z",
    transform: "translate(-52)",
    fill: "#02466a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 10.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M8,52.4a1.2,1.2,0,0,1,1.2,1.2V60A1.2,1.2,0,0,1,8,61.2H1.6A1.2,1.2,0,0,1,.4,60V53.6a1.2,1.2,0,0,1,1.2-1.2H8M8,52H1.6A1.6,1.6,0,0,0,0,53.6V60a1.6,1.6,0,0,0,1.6,1.6H8A1.6,1.6,0,0,0,9.6,60V53.6A1.6,1.6,0,0,0,8,52Z",
    transform: "translate(0 -52)",
    fill: "#02466a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(10.4 10.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M60,52.4a1.2,1.2,0,0,1,1.2,1.2V60A1.2,1.2,0,0,1,60,61.2H53.6A1.2,1.2,0,0,1,52.4,60V53.6a1.2,1.2,0,0,1,1.2-1.2H60m0-.4H53.6A1.6,1.6,0,0,0,52,53.6V60a1.6,1.6,0,0,0,1.6,1.6H60A1.6,1.6,0,0,0,61.6,60V53.6A1.6,1.6,0,0,0,60,52Z",
    transform: "translate(-52 -52)",
    fill: "#02466a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Order);
export default __webpack_public_path__ + "static/media/icon-24-order.3c55d4274117c926e5871cef9dc11682.svg";
export { ForwardRef as ReactComponent };